export const TipoPagamentoEnum = [
    { value: "1", label: "Linha Digitável - Código de Barras" },
    { value: "2", label: "QR Code PIX" },
    { value: "3", label: "Chave Aleatória PIX" },
    { value: "4", label: "TED / Transferência" }
  ]
  